export const PAGENAME = {
  PLP: 'plp_',
  PDP: 'pdp_',
};

export const HARD_NUDGE = 'hard';

export const TRACKING_EVENTS = {
  NUDGE_VISIBLE: 'login_nudge_visible',
  NUDGE_CANCEL_CLICK: 'login_nudge_closed',
  NUDGE_LOGIN_NOW: 'login_nudge_login_now',
  NUDGE_ON_PROCEED: 'login_nudge_onproceed',
};

export enum NUDGE_SOURCES {
  SCROLL_NUDGE = 'scrollNudge',
  NUDGE_VISIBLE = 'nudgeVisible',
}
